import {
  DOWNLOAD_APP_LINK,
  DOWNLOAD_APP_LINK_NO_IOS_FALLBACK,
} from '../constants';

import { getFbCookie } from './getFbCookie';

const buildDownloadLink = (baseUrl: string, userId: string) => {
  const url = new URL(baseUrl);
  url.searchParams.set('deep_link_value', userId);
  url.searchParams.set('deep_link_sub1', 'auth');

  const { fbc, fbp } = getFbCookie();

  if (fbp) {
    url.searchParams.set('af_sub1', fbp);
  }

  if (fbc) {
    url.searchParams.set('af_sub2', fbc);
  }

  return url.href;
};

export const generateDownloadLink = (userId: string) =>
  buildDownloadLink(DOWNLOAD_APP_LINK, userId);

export const generateDownloadLinkNoIosFallback = (userId: string) =>
  buildDownloadLink(DOWNLOAD_APP_LINK_NO_IOS_FALLBACK, userId);
